var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subtitle)?_c('v-card',{staticClass:"d-flex flex-column align-center"},[_c('v-card-title',[_vm._v(_vm._s(_vm.subtitle))]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.description))]),_vm._t("start"),_vm._t("center"),_vm._t("end")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }